import State from '../core/State';
import PageInfo from '../entity/PageInfo';
import { ProjectFilterKey } from '../entity/ProjectFilter';
import { ProjectForAllOfOrganizationFragment } from '../generated/graphql';
import initialState from '../initialState';

export const startFetchingProjects = (key: ProjectFilterKey) => (state: State): State => ({
  ...state,
  projects: {
    ...state.projects,
    [key]: {
      ...state.projects[key],
      fetching: state.projects[key].fetching + 1,
    },
  },
});

export const finishFetchingProjects = (key: ProjectFilterKey) => (state: State): State => ({
  ...state,
  projects: {
    ...state.projects,
    [key]: {
      ...state.projects[key],
      fetching: state.projects[key].fetching - 1,
    },
  },
});

export const setProjects = (
  key: ProjectFilterKey,
  projects: Array<ProjectForAllOfOrganizationFragment>,
  pageInfo: PageInfo | null,
) => (state: State): State => ({
  ...state,
  projects: {
    ...state.projects,
    [key]: {
      ...state.projects[key],
      items: projects,
      pageInfo: pageInfo,
    },
  },
});

export const appendProjects = (
  key: ProjectFilterKey,
  projects: Array<ProjectForAllOfOrganizationFragment>,
  pageInfo: PageInfo | null,
) => (state: State): State => ({
  ...state,
  projects: {
    ...state.projects,
    [key]: {
      ...state.projects[key],
      items: state.projects[key].items.concat(projects),
      pageInfo: pageInfo,
    },
  },
});

export const disposeProjects = () => (state: State): State => ({
  ...state,
  projects: {
    ...state.projects,
    draft: {
      ...state.projects.draft,
      items: initialState.projects.draft.items,
      pageInfo: initialState.projects.draft.pageInfo,
    },
    notDraft: {
      ...state.projects.notDraft,
      items: initialState.projects.notDraft.items,
      pageInfo: initialState.projects.notDraft.pageInfo,
    },
    finalized: {
      ...state.projects.finalized,
      items: initialState.projects.finalized.items,
      pageInfo: initialState.projects.finalized.pageInfo,
    },
  },
});

export const setHasDraftProjects = (hasDraftItems: Array<string>) => (state: State): State => ({
  ...state,
  projects: {
    ...state.projects,
    notDraft: {
      ...state.projects.notDraft,
      hasDraftItems,
    },
  },
});
